import Configuration from '../config';

export const REP_CONTENT_OPEN_ACTIONS = new Set(['open_replayer_tv_match']);

export const findAuthorizedRepContent = (result, videos) => {
  if (!result || !REP_CONTENT_OPEN_ACTIONS.has(result.openAction)) return null;
  return (videos || []).find(video => String(video.id) === String(result.contentId)) || null;
};

export const openAuthorizedRtvVideo = video => {
  if (!video || !video.id || !video.token) return false;
  const url = `${Configuration.krpanoPlayerUrl}?slotId=${encodeURIComponent(video.id)}&token=${encodeURIComponent(video.token)}`;
  const playerWindow = window.open(url, '_blank');
  if (!playerWindow) window.location.href = url;
  return true;
};
